/**
 * Booking entity codes grouped by capability. An account's
 * `bookingEntityCodes` enables a capability when it contains ANY code of the
 * group.
 * - UP: Universe Payments Limited (fiat currencies)
 * - UT: Universe Technologies (digital assets)
 * - UM: Universe Money LLC (digital assets, US)
 */
export const BOOKING_ENTITY = {
  CURRENCIES: ["UP"],
  DIGITAL_ASSETS: ["UT", "UM"],
} as const;

export type BookingEntityGroups = {
  CURRENCIES: readonly string[];
  DIGITAL_ASSETS: readonly string[];
};
